import { AnyAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import reducer from './reducers';

const combinedReducer = combineReducers({
  ...reducer,
});

const rootReducer = (state: RootState, action: AnyAction) => {
  if (action.type === 'logout') {
    // Add any additional logic you need during logout
    state = {} as RootState;
  }
  return combinedReducer(state, action);
};
/**
 * The Redux store for the application.
 * @type {Object}
 */
export const store: any = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself

/**
 * The root state type of the Redux store.
 * @type {ReturnType<typeof store.getState>}
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * The type of the dispatch function in the Redux store.
 * @type {typeof store.dispatch}
 */
export type AppDispatch = typeof store.dispatch;
